module.exports = __webpack_public_path__ + "static/media/198-argentina.d4bb0bf0.svg";